/** Parent-owned gaps around direct children marked as tool calls. */
export const transcriptToolCallSpacing =
  "[&>[data-transcript-tool-call]+*]:mt-[var(--transcript-tool-item-gap,24px)] [&>*+[data-transcript-tool-call]]:mt-[var(--transcript-tool-item-gap,24px)] [&>[data-transcript-tool-call]+[data-transcript-tool-call]]:mt-2";
